// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__2v8mD","tooltip-gsk":"Tooltip_tooltip-gsk__1fyHS"};